module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"p-2 border-bottom-1\"> <div class=\"row\"> <div class=\"col-lg-8 col-7\"> <small>")
    ; __append(escapeFn( locals.readable ))
    ; __append("</small> </div> <div class=\"col-lg-4 col-5\"> <div class=\"bg-img-fluid ")
    ; __append(escapeFn( locals.type ))
    ; __append("\" style=\"height:25px;\"></div> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/carrier_accounts/add_carrier_account/item_template.ejs
// module id = 1328
// module chunks = 1